import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { start } from '@popperjs/core';
import { id } from '@swimlane/ngx-datatable';
import * as bootstrap from 'bootstrap';
import { Modal } from 'bootstrap';
import { get } from 'jquery';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { commonfuctionService } from 'src/app/commonfuction';
import { ConfigService } from 'src/app/services/auth/config.service';
import { CommonService } from 'src/app/services/common.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { UserService } from 'src/app/services/user.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.scss']
})
export class UserprofileComponent implements AfterViewInit,OnInit {
 isEditMode = false; 
userForm: FormGroup;
emailVerified: boolean = false;
maskString: string = '';
txtOTPNumberEmail: string='';
phoneVerfied = false;
emailVerfied:boolean=false;
OTPNumberEmail: string | null = null;
OTPNumber: string | null = null;
otpCode:any='';
countdownEmail: string = '';
countdownMobile: string = '';
existemail:any;
txtOTPNumber:any;
oldmail:any;
oldmobileno:any;


timerIntervalEmail: any;
timerIntervalMobile: any;

resetTimeoutEmail: any;
resetTimeoutMobile: any;
imgurl:any;
 
  constructor( private ngxService: NgxUiLoaderService,private _fd:FormBuilder,private _userService:UserService,private toastService: ToastService,private _Cf:commonfuctionService,private commonService:CommonService,  private encryptService:EncryptionService,private _Cf1:ConfigService) { 

    this.userForm = this._fd.group({
      id: [0],
      sFirstName: ['', [Validators.required, Validators.min(5), Validators.max(40), Validators.pattern(/^[a-zA-Z]{1,40}/)]],
      sLastName: [''],
      sMobile: ['', [Validators.required,Validators.pattern(/^[6-9]\d{9}$/)]],
      sEmail: ['',[Validators.required,Validators.max(251), Validators.pattern(/^[a-zA-Z0-9._%+-]{1,60}@[a-zA-Z.-]{1,190}\.[a-zA-Z]{2,}$/)]],
      sAddress: ['', [Validators.required, Validators.min(20), Validators.max(100)]],
      sImageSrc: [''],
     
    
    });

  }
  ngOnInit(): void {
  
    this.getuserprofile();

  }
  previewImage: string | ArrayBuffer | null = null;

onImageSelected(event: any): void {

  const file = event.target.files[0];

  if (file) {

    const reader = new FileReader();

    reader.onload = () => {
      this.previewImage = reader.result;
    };

    reader.readAsDataURL(file);
  }
}
 
  ngAfterViewInit(): void {
    const profileImg = document.getElementById('profile-img') as HTMLImageElement;

    const imgUpload = document.getElementById('img-upload') as HTMLInputElement;

    profileImg?.addEventListener('click', () => {
      imgUpload?.click();
    });

    imgUpload?.addEventListener('change', (event: Event) => {
      const target = event.target as HTMLInputElement;
      const file = target.files?.[0];
      if (file) {
        const mimeType = file.type; // e.g., "image/jpeg"
    const extension = mimeType.split("/")[1]
    if (extension !== 'jpeg' && extension !== 'jpg' && extension !== 'png') {
          this.toastService.showError('Please upload a valid image file (JPEG, JPG, PNG).');
          return;
        }
        if (file.size > 2 * 1024 * 1024) { // 2MB limit
          this.toastService.showError('Image size exceeds 2MB. Please upload a smaller image.');
          return;
        }

        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
          if (e.target?.result && profileImg) {
            profileImg.src = e.target.result as string;
            this.userForm.patchValue({
              sImageSrc: e.target.result as string
            });
          }
        };
        reader.readAsDataURL(file);
      }
    });
  }
  onSubmit() {
    if (this.userForm.valid) {
      // Perform further actions, such as sending the form data to a server
    } else {
    }
  }
  getuserprofile(){
    this._userService.getLoginUser().subscribe({
      next: (response) => {
        if (response.status === 200) {
          console.log(response)
          this.existemail = response.data.sEmail;
          this.oldmail = response.data.sEmail;
          this.oldmobileno = response.data.sMobile;
          this.userForm.patchValue({
            sFirstName: response.data.sFirstName,
            sLastName: response.data.sLastName,
            sMobile: response.data.sMobile,
            sEmail: response.data.sEmail,
            sAddress: response.data.sAddress,
           // sImageSrc: response.data.sImageSrc? this._Cf1.getprofileUrl()+response.data.sImageSrc : '',
            id: response.data.id,
          });
          this.imgurl = response.data.sImageSrc? this._Cf1.getprofileUrl()+response.data.sImageSrc : '';
     
        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.toastService.showError(error.message);
      },
    });
  }
     checkDuplicateEmailOrMobile(flag:number) {
      this.ngxService.start();
    let emailId='';
    let mobile='';
    if(flag==1){
       const control = this.userForm.get('sEmail');
       if(this.existemail==this.userForm.get('sEmail')?.value){
        this.toastService.showError('Email already exist');
        this.ngxService.stop();
        return;
       }
      if (control?.valid) {
        this.maskString = this._Cf.maskMobileOrEmail(this.userForm.get('sEmail')?.value,1);
        emailId = this.userForm.get('sEmail')?.value;
        if(this.OTPNumberEmail){
          this.ngxService.stop();
          this.openModal('otpEmailModal');
          return;
        }
      }else{
        this.ngxService.stop();
        return;
      }
    }
    if(flag==2){
      const control = this.userForm.get('sMobile');
      if (control?.valid) {
        this.maskString = this._Cf.maskMobileOrEmail(this.userForm.get('sMobile')?.value,2);
        mobile = this.userForm.get('sMobile')?.value;
        if(this.OTPNumber){
          this.ngxService.stop();
          this.openModal('otpPhoneModal');
          return;
        }
      }else{
        this.ngxService.stop();
        return;
      }
      
    }
 this.commonService.CheckDuplicateEmailOrMobile(emailId, mobile).subscribe((response) => {
      if (response.status === 200) {
        console.log(response)
          // const cipherText = response.data.cipherText;
          // const iv = response.data.iv;
          // const plainText = this.encryptService.decrypt(cipherText, iv);
          const plainText = response.data;
          
           // Start 10-minute timer
          const totalSeconds = 600;
          let secondsLeft = totalSeconds;
          if (flag === 1) {
            this.OTPNumberEmail = plainText;
            this.updateCountdown(flag, secondsLeft);
            this.timerIntervalEmail = setInterval(() => {
              secondsLeft--;
              this.updateCountdown(flag, secondsLeft);
              if (secondsLeft <= 0) this.clearDecryptedText(flag);
            }, 1000);

            this.resetTimeoutEmail = setTimeout(() => this.clearDecryptedText(flag), totalSeconds * 1000);
            this.ngxService.stop();
            this.openModal('otpEmailModal');
          }

          if (flag === 2) {
            this.OTPNumber = plainText.otp;
            this.updateCountdown(flag, secondsLeft);
            this.timerIntervalMobile = setInterval(() => {
              secondsLeft--;
              this.updateCountdown(flag, secondsLeft);
              if (secondsLeft <= 0) this.clearDecryptedText(flag);
            }, 1000);

            this.resetTimeoutMobile = setTimeout(() => this.clearDecryptedText(flag), totalSeconds * 1000);
            this.ngxService.stop();
            this.openModal('otpPhoneModal');        
          }

      }else{
        this.ngxService.stop();
        this.toastService.showError(response.message);
        if(flag==2){
        this.userForm.controls['sMobile'].setValue('');
        return;
        }
        if(flag==1){
        this.userForm.controls['sEmailId'].setValue('');
        return;
        }

      }
    })
    
  }
    openModal(model:any) {
      
      const modalElement = document.getElementById(model);
      if (modalElement) {
        const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
        modalInstance.show();
      
      }
    }
    allowOnlyNumbers(event: KeyboardEvent) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    }
    verifyOTP(flag:any){
      
      if(flag==1){
      if(this.txtOTPNumberEmail===this.OTPNumberEmail){
        this.emailVerified=true;
        this.toastService.showSuccess('OTP verified successfully.');
        this.txtOTPNumberEmail='';
        this.closeModal('otpEmailModal');
      }
      else{
        this.emailVerified=false;
        this.toastService.showError('Please enter a valid 6-digit OTP.');
      }
    }
    if(flag==2){
      if(this.txtOTPNumber===this.OTPNumber){
        this.phoneVerfied=true;
        this.toastService.showSuccess('OTP verified successfully.');
        this.txtOTPNumber='';
        this.closeModal('otpPhoneModal');
      }
      else{
        this.phoneVerfied=false;
        this.toastService.showError('Please enter a valid 6-digit OTP.');
      }
    }
  }
    closeModal(modalId: string) {
      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        modalInstance?.hide();
      }
    }
    closeOtPModel(){
      this.otpCode=''
    }
    updateCountdown(flag: number, secondsLeft: number) {
      const minutes = Math.floor(secondsLeft / 60);
      const seconds = secondsLeft % 60;
      const display = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  
      if (flag === 1) {
        this.countdownEmail = display;
      } else if (flag === 2) {
        this.countdownMobile = display;
      }
    }
    clearDecryptedText(flag: number) {
      if (flag === 1) {
        this.OTPNumberEmail = null;
        clearInterval(this.timerIntervalEmail);
        clearTimeout(this.resetTimeoutEmail);
        this.countdownEmail = '';
      } else if (flag === 2) {
        this.OTPNumber = null;
        clearInterval(this.timerIntervalMobile);
        clearTimeout(this.resetTimeoutMobile);
        this.countdownMobile = '';
      }
    }
    Submitdata() {
    
      this.ngxService.start();
       if (this.userForm.valid) 
      {
        const formData = this.userForm.value;
        if(formData.sEmail !== this.oldmail && this.emailVerified === false){
          this.toastService.showError('Please verify your email before updating.');
          this.ngxService.stop();
          return;
        }
        if(formData.sMobile !== this.oldmobileno && this.phoneVerfied === false){
          this.toastService.showError('Please verify your mobile number before updating.');
          this.ngxService.stop();
          return;
        }
        
        if(this.previewImage){
           formData.sImageSrc= this.previewImage
        }
        console.log(formData);
        
          this._userService.updateUserProfile(formData).subscribe({
            next: (response) => {
              if (response.status === 200) {
                this.toastService.showSuccess(response.message);
                this.ngxService.stop();
                this.getuserprofile();
                this.isEditMode = false;
              } else {
                this.toastService.showError(response.message);
                this.ngxService.stop();
              }
            },
            error: (error) => {
              this.toastService.showError(error.message);
              this.ngxService.stop();
            }
          });
        
       
      } else {
        this.toastService.showError('Please fill all required fields correctly.');
        this.ngxService.stop();
      }

    }
}
